import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

// Enhanced styled components for a professional, legal document appearance
const Container = styled.div`
  font-family: 'Georgia', serif;
  line-height: 2;
  color: #2d2d2d;
  padding: 30px;
  max-width: 850px;
  margin: auto;
  background-color: #fafafa;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-family: 'Helvetica Neue', sans-serif;
  color: #1a1a1a;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 10px;
`;

const SubTitle = styled.h2`
  font-family: 'Helvetica Neue', sans-serif;
  color: #4a4a4a;
  font-size: 24px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 15px;
`;

const Paragraph = styled.p`
  font-size: 20px;
  margin-bottom: 15px;
`;



const LegalReference = styled.span`
  font-family: 'Courier New', monospace;
  font-style: italic;
  color: #707070;
`;

const StyledButton = styled.button`
  font-family: 'Helvetica Neue', sans-serif;
  background-color: #4a90e2;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3e7cb1;
  }
`;

const PrivacyAndTerms = ({  }) => {
    const [currentDate, setCurrentDate] = useState('');
  const [lastUpdatedDate, setLastUpdatedDate] = useState('12/31/2023');
    useEffect(() => {
      window.scrollTo(0, 0);
  
      // Get the current date
      const today = new Date();



      // Format the date as MM/DD/YYYY
      const formattedDate = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
  
      // Set the current date in the state
      setCurrentDate(formattedDate);
     
    }, []);
  
    let navigate = useNavigate();

  return (
    <Container>
      <Title>Privacy Policy</Title>
      <Paragraph>Last Updated: <LegalReference>{lastUpdatedDate}</LegalReference></Paragraph>
      <Paragraph>Current Date: <LegalReference>{currentDate}</LegalReference></Paragraph>
   <Paragraph>
        This Privacy Policy elucidates the modalities through which Nirvanis ("we," "us," or "our") collects, utilizes, discloses, and safeguards the personal information you proffer or that we accrue in the course of your usage of our website, platform, or services (collectively, the "Service"). Your access to and use of our Service constitutes your assent to the stipulations of this Privacy Policy.
      </Paragraph>

      <SubTitle>1. Information Collection</SubTitle>
      <Paragraph>The categories of information we may accumulate are as follows:</Paragraph>

      <SubTitle>1.1. Personally Identifiable Information</SubTitle>
      <Paragraph>
        This encompasses, but is not limited to, your name, email address, and any other particulars you furnish during registration or in the course of utilizing our Service.
      </Paragraph>

      <SubTitle>1.2. Usage Data</SubTitle>
      <Paragraph>
        We collect data pertaining to your interactions with our Service, including, without limitation, your IP address, browser type, device particulars, and the pages you visit.
      </Paragraph>

      <SubTitle>2. Utilization of Information</SubTitle>
      <Paragraph>The information collected may be employed for diverse purposes, including, but not limited to:</Paragraph>

      <SubTitle>2.1. Service Provision and Enhancement</SubTitle>
      <Paragraph>
        To furnish, sustain, and augment our Service, as well as to develop new functionalities and features.
      </Paragraph>

      <SubTitle>2.2. Communication</SubTitle>
      <Paragraph>
        To transmit updates, newsletters, and other pertinent information related to our Service.
      </Paragraph>

      <SubTitle>3. Disclosure of Information</SubTitle>
      <Paragraph>Under certain circumstances, we may divulge your information:</Paragraph>

      <SubTitle>3.1. To Third Parties</SubTitle>
      <Paragraph>
        We may entrust your information to reputable third parties who aid us in operating, maintaining, and enhancing our Service.
      </Paragraph>

      <SubTitle>4. Information Management</SubTitle>
<Paragraph>
    You have the right to manage, update, or request the deletion of your personal information. For assistance with managing your information or if you wish to opt out of certain communications, please contact us using the designated contact information provided on our Service.
</Paragraph>


      <SubTitle>5. Data Security</SubTitle>
      <Paragraph>
        We undertake reasonable measures to safeguard your information; however, no electronic data transmission or storage system is impervious to breach. We cannot assure the absolute security of your information.
      </Paragraph>

      <SubTitle>6. Policy Amendments</SubTitle>
      <Paragraph>
        We reserve the right to modify this Privacy Policy at our discretion. Any alterations will be communicated via an updated Privacy Policy on our website.
      </Paragraph>

      <Title>Terms and Conditions</Title>
      <Paragraph>Last Updated: <LegalReference>{lastUpdatedDate}</LegalReference></Paragraph>

      <Paragraph>
        These Terms and Conditions ("Terms") govern your engagement with the NirvanaNFT platform and services. Your utilization of our platform or services signifies your compliance with these Terms.
      </Paragraph>

      <SubTitle>1. Platform Usage</SubTitle>

      <SubTitle>1.1. Eligibility</SubTitle>
      <Paragraph>
        You are obliged to be of legal age in your jurisdiction to utilize our platform and services. Your use of our platform must not contravene any applicable laws or regulations.
      </Paragraph>

      <SubTitle>2. Intellectual Property Rights</SubTitle>
      <Paragraph>
        All content present on our platform, inclusive of text, graphics, logos, and software, is the property of NirvanaNFT or its licensors and is protected under copyright and other intellectual property laws.
      </Paragraph>

      <SubTitle>3. Disclaimers</SubTitle>
      <Paragraph>3.1. The accuracy and reliability of any information or content on our platform are not guaranteed.</Paragraph>
      <Paragraph>3.2. You utilize our platform and services at your own risk.</Paragraph>

      <SubTitle>4. Limitation of Liability</SubTitle>
      <Paragraph>
        Nirvanis disclaims any liability for direct, indirect, incidental, or consequential damages arising from your use of our platform or services.
      </Paragraph>

      <SubTitle>5. Governing Law</SubTitle>
      <Paragraph>
        These Terms are governed by the laws of Your Jurisdiction, with any disputes to be resolved in the courts of Your Jurisdiction.
      </Paragraph>

      <SubTitle>6. Non-Investment Declaration</SubTitle>
      <Paragraph>
        Participation in Nirvanis, including but not limited to its tokens or NFTs, does not constitute an investment contract or financial instrument. Involvement in our platform and services is not to be construed as an investment.
      </Paragraph>
      <StyledButton onClick={() => navigate('/')}>
      Back to Home
    </StyledButton>
    </Container>
  );
};

export default PrivacyAndTerms;
